var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalad = function SvgSalad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "salad_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#salad_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 42.616c0-.69.56-1.25 1.25-1.25h20a1.25 1.25 0 0 1 0 2.5h-20c-.69 0-1.25-.56-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.366 23.732a1.25 1.25 0 0 1 .884-.366h36a1.25 1.25 0 0 1 1.25 1.25 19.25 19.25 0 1 1-38.5 0c0-.331.132-.65.366-.884Zm2.18 2.134a16.75 16.75 0 0 0 33.407 0H6.547Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.728 8.506a3.55 3.55 0 0 0-2.406.753 1.25 1.25 0 0 1-1.524.016 3.55 3.55 0 0 0-5.133.931 1.25 1.25 0 0 1-1.502.497 3.55 3.55 0 0 0-4.734 4.098 1.25 1.25 0 0 1-1.022 1.51 3.55 3.55 0 0 0 .591 7.055 1.25 1.25 0 0 1 .024 2.5 6.05 6.05 0 0 1-2.179-11.715 6.048 6.048 0 0 1 7.291-6.054 6.052 6.052 0 0 1 7.4-1.311 6.05 6.05 0 0 1 8.246 8.246 6.052 6.052 0 0 1-2.306 8.114 6.27 6.27 0 0 1-.097 1.71 1.25 1.25 0 0 1-2.454-.48 3.769 3.769 0 0 0-.045-1.653 1.25 1.25 0 0 1 .786-1.482 3.55 3.55 0 0 0 1.627-5.473 1.25 1.25 0 0 1 .016-1.524 3.55 3.55 0 0 0-2.58-5.738Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.134 15.732a1.25 1.25 0 0 1 0 1.768l-8 8a1.25 1.25 0 1 1-1.768-1.768l8-8a1.25 1.25 0 0 1 1.768 0ZM11.813 12.002a9.23 9.23 0 0 1 10.149 2.259 1.25 1.25 0 1 1-1.824 1.71A6.73 6.73 0 0 0 8.5 20.61v.006c0 1.227.335 2.374.913 3.376a1.25 1.25 0 0 1-2.166 1.248A9.229 9.229 0 0 1 6 20.62a9.23 9.23 0 0 1 5.813-8.618Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 25H6v4.5l6.5 10 11 3.5 7-1.5L39 34l2-9Z"
  }))));
};
export default SvgSalad;